import * as _ from 'lodash';
import { OptionItem } from '../../diagram/utils/option-item';
import { ZoomOperation } from './zoom-operation';
var zoomTypes = [
    new OptionItem(0.1, '10%'),
    new OptionItem(0.25, '25%'),
    new OptionItem(0.5, '50%'),
    new OptionItem(0.75, '75%'),
    new OptionItem(1, '100%'),
    new OptionItem(1.25, '125%'),
    new OptionItem(1.5, '150%'),
    new OptionItem(2, '200%'),
    new OptionItem(2.5, '250%'),
    new OptionItem(3, '300%'),
    new OptionItem(3.5, '350%'),
    new OptionItem(4, '400%')
];
var defaultScales = _.map(zoomTypes, function (value) { return value.key; }).sort();
var ZoomHelper = /** @class */ (function () {
    function ZoomHelper() {
    }
    ZoomHelper.getZoom = function (oldZoom, operation) {
        var typeIndex = _.findIndex(this.zoomTypes, function (type) { return type.key === oldZoom; });
        var newZoom = oldZoom;
        switch (operation) {
            case ZoomOperation.Increase:
                if (typeIndex !== -1 && typeIndex < this.zoomTypes.length - 1) {
                    newZoom = this.zoomTypes[typeIndex + 1].key;
                }
                break;
            case ZoomOperation.Decrease:
                if (typeIndex !== -1 && typeIndex !== 0) {
                    newZoom = this.zoomTypes[typeIndex - 1].key;
                }
                break;
        }
        return newZoom;
    };
    ZoomHelper.adjustScale = function (scale, operation) {
        for (var index = 0; index < defaultScales.length; index++) {
            var defaultScale = defaultScales[index];
            if (defaultScale > scale) {
                if (operation === ZoomOperation.Increase) {
                    return defaultScale;
                }
                else {
                    if (index > 0) {
                        return defaultScales[index - 1];
                    }
                }
            }
        }
        return scale;
    };
    ZoomHelper.canScale = function (oldZoom, newZoom) {
        if (oldZoom === newZoom) {
            return false;
        }
        var typeIndex = _.findIndex(this.zoomTypes, function (type) { return type.key === newZoom; });
        if (typeIndex !== -1) {
            return false;
        }
        return true;
    };
    ZoomHelper.defaultZoom = 1;
    ZoomHelper.defaultMinScale = 0.1;
    ZoomHelper.defaultMaxScale = 4;
    ZoomHelper.zoomTypes = zoomTypes;
    return ZoomHelper;
}());
export { ZoomHelper };
